module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n  Tags: "), _c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("tag")]), _vm._v(" "), _vm._l((_vm.appointment.tags), function(tag) {
    return [(_vm.successfullyDeleted.indexOf(tag) === -1) ? _c('v-chip', {
      key: tag,
      attrs: {
        "close": _vm.deleteable && _vm.tagBeingDeleted === null,
        "small": "",
        "dark": "",
        "color": "primary"
      },
      on: {
        "input": function($event) {
          return _vm.remove(tag)
        }
      }
    }, [(tag === _vm.tagBeingDeleted) ? _c('v-progress-circular', {
      staticClass: "mr-2",
      attrs: {
        "indeterminate": "",
        "size": "12",
        "width": "1"
      }
    }) : _vm._e(), _vm._v("\n      " + _vm._s(tag) + "\n    ")], 1) : _vm._e()]
  }), _vm._v(" "), _c('v-chip', {
    attrs: {
      "outline": "",
      "outlined": "",
      "color": "primary",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.launchAppointmentTags({
          appointmentIds: [_vm.appointment.id],
          touch: Math.random()
        })
      }
    }
  }, [_c('v-icon', [_vm._v("add")]), _vm._v("\n    " + _vm._s(_vm.$t('buttons.add')) + "\n  ")], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21d562f9","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/appointment/TagList.vue
// module id = 1354
// module chunks = 9